import React from "react";

interface Props {
  isActive: boolean;
}

export default function MyClaimsIcon({ isActive }: Props) {
  return (
    <svg
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21.463V22H0V3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0L15 0C15.7956 0 16.5587 0.31607 17.1213 0.87868C17.6839 1.44129 18 2.20435 18 3V11.809C16.7162 11.0633 15.2013 10.8206 13.7488 11.1281C12.2963 11.4356 11.0096 12.2712 10.1381 13.4732C9.26653 14.6752 8.87219 16.1579 9.03143 17.634C9.19067 19.1101 9.89217 20.4746 11 21.463ZM4 6H14V4H4V6ZM4 10H14V8H4V10ZM4 14H9V12H4V14Z"
        fill={isActive ? "#5E9918" : "#B3B3B3"}
      />
      <path
        d="M17 20.4441V24.0001L15 22.0001L13 24.0001V20.4441C12.2374 20.0038 11.6415 19.3242 11.3045 18.5107C10.9675 17.6972 10.9084 16.7952 11.1363 15.9447C11.3642 15.0942 11.8664 14.3426 12.565 13.8066C13.2635 13.2705 14.1195 12.98 15 12.98C15.8805 12.98 16.7365 13.2705 17.435 13.8066C18.1336 14.3426 18.6358 15.0942 18.8637 15.9447C19.0916 16.7952 19.0325 17.6972 18.6955 18.5107C18.3586 19.3242 17.7626 20.0038 17 20.4441Z"
        fill={isActive ? "#9DCD5A" : "#B3B3B3"}
      />
    </svg>
  );
}
